import {RootState} from '@/store'
import {FundsState} from "@/store/modules/fund/index";
import {GetterTree} from 'vuex'

export const getters: GetterTree<FundsState, RootState> = {

}